// This will be used for writing custom JS.



// Script to fix header hover that arises from frame.js : Starts
(function () {
  function initHeaderHover() {
    const header = document.querySelector('#header');
    if (!header) return;
    // Prevent duplicate listeners
    if (header.classList.contains('lo-hover-init')) return;
    header.classList.add('lo-hover-init');

    header.addEventListener('mouseenter', () => {
      header.classList.add('lo-hover');
    });

    header.addEventListener('mouseleave', () => {
      header.classList.remove('lo-hover');
    });
  }

  document.addEventListener('DOMContentLoaded', initHeaderHover);
  document.addEventListener('shopify:section:load', initHeaderHover);
})();


// Script to fix header hover that arises from frame.js : Ends

// TEPO length radios have no shared name, so every click stays checked.
(function () {
  document.addEventListener('click', function (event) {
    const label = event.target.closest('.tcustomizer-field--RadioButton label.tcustomizer-btn');
    if (!label) return;
    const field = label.closest('.tcustomizer-field--RadioButton');
    if (!field) return;

    field.querySelectorAll('input.tcustomizer__btn-check').forEach((radio) => {
      const radioLabel = radio.id ? field.querySelector('label[for="' + CSS.escape(radio.id) + '"]') : null;
      if (radioLabel !== label) radio.checked = false;
    });

    field.querySelectorAll('label.tcustomizer-btn--active').forEach((active) => {
      if (active !== label) active.classList.remove('tcustomizer-btn--active');
    });
    label.classList.add('tcustomizer-btn--active');
    const value = field.querySelector('.tcustomizer-field__value');
    if (value) value.textContent = label.textContent.replace(/\s+/g, ' ').trim();
    field.classList.remove('is-length-open');
    const toggle = field.querySelector('.product-length-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    syncHemShippingPromise(field.closest('.product-information') || document);
  });

  function syncHemShippingPromise(scope) {
    scope.querySelectorAll('[data-promise="shipping"]').forEach((item) => {
      const info = item.closest('.product-information') || document;
      const active = info.querySelector('.tcustomizer-field--RadioButton .tcustomizer-btn--active');
      const text = active ? active.textContent.replace(/\s+/g, ' ').trim() : '';
      const hemmed = text.length > 0 && !/no hemming/i.test(text);
      const label = item.querySelector('[data-promise-label]');
      if (!label) return;
      const next = hemmed ? item.getAttribute('data-hemmed') : item.getAttribute('data-standard');
      if (label.textContent !== next) label.textContent = next;
    });
  }

  function setupLengthDisclosure(info) {
    info.querySelectorAll('.tcustomizer-field--RadioButton').forEach((field) => {
      const title = field.querySelector('.tcustomizer-field__heading > span');
      if (title && /^select length$/i.test(title.textContent.trim())) title.textContent = 'Length';
      if (field.dataset.lengthDisclosure) return;
      field.dataset.lengthDisclosure = 'true';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'product-length-toggle';
      button.textContent = 'Change length';
      button.setAttribute('aria-expanded', 'false');
      const heading = field.querySelector('.tcustomizer-field__heading');
      if (heading) heading.insertAdjacentElement('afterend', button);

      button.addEventListener('click', function () {
        const open = field.classList.toggle('is-length-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function syncSaleBadge(info) {
    const badge = info.querySelector('.product-sale-badge');
    if (!badge) return;
    const onSale = !!info.querySelector('.product-price-container .amount.discounted');
    if (badge.hidden === !onSale) return;
    badge.hidden = !onSale;
  }

  function formatHemNote(info) {
    info.querySelectorAll('.tcustomizer__description').forEach((note) => {
      if (note.querySelector('.product-length-note')) return;
      const text = note.textContent.replace(/\s+/g, ' ').trim();
      if (!/standard inseam of 33\.5/i.test(text)) return;

      const list = document.createElement('ul');
      list.className = 'product-length-note';
      [
        'Please allow up to 2 extra weeks for shipping.',
        'If complimentary hemming is chosen, the item becomes non-returnable.'
      ].forEach((line) => {
        const item = document.createElement('li');
        item.textContent = line;
        list.appendChild(item);
      });
      note.replaceChildren(list);
    });
  }

  function placeFindYourSize(info) {
    const block = info.querySelector('#measmerize-button')?.closest('.shopify-app-block');
    if (!block) return;
    const sizeField = info.querySelector('.product-form__input[data-handle="size"]');
    if (sizeField && block.previousElementSibling !== sizeField) sizeField.after(block);
    if (!block.querySelector('.product-size-help')) {
      const label = document.createElement('span');
      label.className = 'product-size-help';
      label.textContent = 'Need help?';
      block.prepend(label);
    }
  }

  function watchHemShippingPromise() {
    document.querySelectorAll('.product-information').forEach((info) => {
      if (info.dataset.promiseWatch) return;
      info.dataset.promiseWatch = 'true';
      let updating = false;
      const refresh = () => {
        if (updating) return;
        updating = true;
        syncHemShippingPromise(info);
        setupLengthDisclosure(info);
        formatHemNote(info);
        placeFindYourSize(info);
        syncSaleBadge(info);
        updating = false;
      };
      refresh();
      const observer = new MutationObserver(refresh);
      observer.observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchHemShippingPromise);
  } else {
    watchHemShippingPromise();
  }
})();